import { classNames } from '@ember-decorators/component';
import PatternForm from './pattern-form';
import styles from './pattern-form-redesign.module.scss';

@classNames(styles.component)
export default class SharedPatternFormRedesign extends PatternForm {
  styles = styles;
}
